import { WindowWithMtm } from "./interfaces/window";
import { productKey } from "./constants";

export declare let window: WindowWithMtm;

export const rewriteStringwithCaps = (str: string): string => {
  return str
    ?.split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const addDataLayer = (
  dataLayer: any,
  eventIdentifier: string,
  eventName: string = "dlv_track"
) => {
  // Matomo Analytics
  if (window && window._mtm !== undefined && window._mtm !== null) {
    window._mtm.push({
      event: eventName,
      dlv_eventData: { eventIdentifier, contextData: dataLayer },
    });
  }
  // Google Analytics
  if (window && window.dataLayer !== undefined && window.dataLayer !== null) {
    window.dataLayer.push({ event: eventIdentifier, ...dataLayer });
  }
};

export function mtm_getUtmParamsFromSession(): string {
  const matomoId = window?.MatomoTagManager?.containers?.[0]?.idsite;
  return matomoId
    ? sessionStorage.getItem(`matomo_${matomoId}_utmParams`) || ""
    : "";
}

export function mtm_clearUtmParamsFromSession(): void {
  const matomoId = window?.MatomoTagManager?.containers?.[0]?.idsite;
  sessionStorage.removeItem(`matomo_${matomoId}_utmParams`);
}

export function mtm_hasSpecialOfferCampaign(): boolean {
  const utmParams = mtm_getUtmParamsFromSession();
  return utmParams.includes("utm_promo=special_offer");
}

/**
 * Appends UTM parameters to all anchor (`<a>`) tags in the provided HTML content.
 * @param {string} htmlContent  
 * @param {string} utmParams  
 * @returns {string}  
 */
export const appendUtmParamsToLinks = (htmlContent: string): string => {
  const utmParams = mtm_getUtmParamsFromSession();
  if (!utmParams) return htmlContent;
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  const links = doc.querySelectorAll("a");

  const appendedUtmParams = utmParams.replace(/^\?/, ""); 

  links.forEach((link) => {
    const currentHref = link.getAttribute("href");
    if (currentHref && !currentHref.includes(appendedUtmParams)) {
      link.href = `${currentHref}${currentHref.includes("?") ? "&" : "?"}${appendedUtmParams}`;
    }
  });

  return doc.body.innerHTML;
};

export const formatDecimalsWithCommas = (value: string | number): string => {
  const num = typeof value === "number" ? value : parseFloat(value);
  return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatNumberWithCommas = (value: number): string => {
  return value.toLocaleString("en-US");
};

export const stripHtmlTags = (input: string): string => {
  const doc = new DOMParser().parseFromString(input, "text/html");
  return doc.body.textContent ?? "";
};

export const generateSecureRandomId = (): number => {
  const array = new Uint32Array(1);
  const cryptoObj = window.crypto || (window as any).msCrypto;
  cryptoObj.getRandomValues(array);
  return array[0];  
};